// extracted by mini-css-extract-plugin
export default {"info-box":"AdminHome_info-box__qA3+c","card":"AdminHome_card__2o5+X","card1":"AdminHome_card1__3rqQs","card2":"AdminHome_card2__h+6am","card3":"AdminHome_card3__TF-5i"};